import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M5 5v14h14v-7h2v7c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7v2H5zm9 0V3h7v7h-2V6.4l-9.83 9.83-1.4-1.4L17.6 5H14z";

export default function ExternalLink(props: IconProps) {
  return <SVGIcon path={path} {...props} />;
}
